import { render } from "./AllBillPage.vue?vue&type=template&id=367675a0&scoped=true"
import script from "./AllBillPage.vue?vue&type=script&lang=js"
export * from "./AllBillPage.vue?vue&type=script&lang=js"

import "./AllBillPage.vue?vue&type=style&index=0&id=367675a0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-367675a0"]])

export default __exports__